import clientRequest from '@/lib/client-request';
import {
  Category,
  DiscountInfo,
  NewUserTrial,
  Plan,
  Product,
} from '@/app/actions/cart';

export function getProducts(): Promise<
  DataResponse<{
    categories: Category[];
    products: Product[];
    discounts: DiscountInfo[];
  }>
> {
  return clientRequest.get('/cart/get_products');
}

export function findMaxPercentageDiscount(
  discounts: DiscountInfo[],
): DiscountInfo | null {
  if (!discounts || discounts.length === 0) {
    return null;
  }

  let maxPercentageDiscount: DiscountInfo | null = null;
  let maxPercentage = -1;

  for (const discount of discounts) {
    if (
      discount.percentage !== undefined &&
      discount.percentage > maxPercentage
    ) {
      maxPercentage = discount.percentage;
      maxPercentageDiscount = discount;
    }
    if (
      discount.fixed_amount !== undefined &&
      discount.fixed_amount > maxPercentage
    ) {
      maxPercentage = discount.fixed_amount;
      maxPercentageDiscount = discount;
    }
  }

  return maxPercentageDiscount;
}

export function getClientPlans(): Promise<DataResponse<Plan[]>> {
  return clientRequest.get('/cart/plans');
}

export function getClientNewUserTrial(): Promise<DataResponse<NewUserTrial>> {
  return clientRequest.get('/cart/new-user-trial');
}

export async function queryOrderStatus(
  orderId: string,
): Promise<{ status: string }> {
  const { data } = await clientRequest.post<
    unknown,
    DataResponse<{ status: string }>
  >('/cart/query_order', { order_id: orderId });
  return data;
}
